/** Categorias, tipos de negócio e tipos de oportunidade. */
export const DEFAULT_CATEGORIES = [
  { id: 'tecnologia', name: 'Tecnologia e software', icon: 'Cpu' },
  { id: 'marketing', name: 'Marketing e publicidade', icon: 'Megaphone' },
  { id: 'industria', name: 'Indústria e fabricação', icon: 'Factory' },
  { id: 'construcao', name: 'Construção civil', icon: 'HardHat' },
  { id: 'comercio', name: 'Comércio e varejo', icon: 'ShoppingBag' },
  { id: 'saude', name: 'Saúde e bem-estar', icon: 'HeartPulse' },
  { id: 'servicos-profissionais', name: 'Serviços profissionais', icon: 'Briefcase' },
  { id: 'consultoria', name: 'Consultoria empresarial', icon: 'LineChart' },
  { id: 'logistica', name: 'Logística e transporte', icon: 'Truck' },
  { id: 'agronegocio', name: 'Agronegócio', icon: 'Wheat' },
  { id: 'alimentacao', name: 'Alimentação', icon: 'UtensilsCrossed' },
  { id: 'educacao', name: 'Educação e treinamento', icon: 'GraduationCap' },
  { id: 'servicos-empresas', name: 'Serviços para empresas', icon: 'Building2' },
  { id: 'outros', name: 'Outros', icon: 'Shapes' },
].map((c) => ({ ...c, active: true }));

export const BUSINESS_TYPES = [
  { id: 'servicos', name: 'Prestador de serviços' },
  { id: 'comercio', name: 'Comércio' },
  { id: 'industria', name: 'Indústria' },
  { id: 'distribuicao', name: 'Distribuição e atacado' },
  { id: 'startup', name: 'Startup' },
  { id: 'autonomo', name: 'Profissional autônomo' },
  { id: 'produtor', name: 'Produtor rural' },
];

export const OPPORTUNITY_TYPES = [
  { id: 'fornecedores', name: 'Procura de fornecedores', short: 'Fornecedores' },
  { id: 'distribuidores', name: 'Procura de distribuidores', short: 'Distribuidores' },
  { id: 'representantes', name: 'Procura de representantes comerciais', short: 'Representantes' },
  { id: 'parceria', name: 'Parceria estratégica', short: 'Parceria' },
  { id: 'oferta', name: 'Oferta de serviços', short: 'Oferta de serviços' },
  { id: 'terceirizacao', name: 'Oportunidade de terceirização', short: 'Terceirização' },
  { id: 'clientes', name: 'Busca por clientes corporativos', short: 'Clientes B2B' },
  { id: 'colaboracao', name: 'Proposta de colaboração comercial', short: 'Colaboração' },
];

export const REPORT_REASONS = [
  { id: 'fraude', name: 'Fraude ou golpe' },
  { id: 'spam', name: 'Spam ou conteúdo repetitivo' },
  { id: 'assedio', name: 'Assédio' },
  { id: 'ameaca', name: 'Ameaça ou incitação à violência' },
  { id: 'discriminacao', name: 'Conteúdo discriminatório' },
  { id: 'falsa', name: 'Informação falsa ou enganosa' },
  { id: 'outro', name: 'Outro motivo' },
];

export const CONTACT_METHODS = [
  { id: 'form', name: 'Formulário da plataforma' },
  { id: 'whatsapp', name: 'WhatsApp comercial da empresa' },
  { id: 'email', name: 'E-mail comercial' },
  { id: 'site', name: 'Site oficial' },
];

export const BUSINESS_TYPE_NAME = Object.fromEntries(BUSINESS_TYPES.map((b) => [b.id, b.name]));
export const OPP_TYPE_BY_ID = Object.fromEntries(OPPORTUNITY_TYPES.map((t) => [t.id, t]));
export const REPORT_REASON_NAME = Object.fromEntries(REPORT_REASONS.map((r) => [r.id, r.name]));
